import { signal } from "@preact/signals-core";

export interface Breadcrumb {
  label: string;
  path: string;
}

/**
 * Set by a second-level detail view (company/client/project) on mount, cleared via its
 * scope's cleanup on navigating away. The shell renders it as a "back to list" link
 * while keeping the corresponding top-level nav item highlighted (path-prefix match,
 * not this signal) — see shell.ts.
 */
export const breadcrumb = signal<Breadcrumb | null>(null);
